<div
  ppTooltip
  [ppSanitize]="false"
  [ppTitle]="tooltipText"
  class="customFieldCell__content"
  [attr.data-test]="ppCustomField.label + '~' + ppCustomField.id"
>
  @if (integrationIcon) {
    <img [src]="integrationIcon" />
  }

  {{ ppCustomField.label }}
</div>
